
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSideBarContext } from '../context/SidebarContext';
import Headings from './Headings';

const Layout = () => {
    const { isSidebarHidden } = useSideBarContext();
    // const location = useLocation();
    // const { isSidebarHidden } = useSideBarContext();
    // const [showBreadcrumb, setShowBreadcrumb] = useState(false);

    // const handleEyeClick = () => {
    //     setShowBreadcrumb(true);
    // };

    // console.log(location.pathname, "loayout")

    // useEffect(() => {
    //     if (location.pathname.includes('detail')) {
    //         setShowBreadcrumb(true);
    //     }
    // }, [location.pathname]);

    return (

        <>
            <Sidebar />
            <div className={`main-wrapper ${isSidebarHidden ? 'main-width' : ''}`}>

                <Header />
                <Headings />
                <Outlet />


                {/* <Outlet context={{ handleEyeClick }} /> */}
            </div>

        </>

    );
};

export default Layout;
